enum EncounterItemTypeEnum {
    ClinicalForms = 0,
    PatientForms,
    APSSForm,
    Prescription,
    PrivateBill,
    MedfarBilling,
    Request,
    ConsultationRequest,
    HandwrittenNotes,
    MedicalItem,
    CnesstForm,
    ObstetricalFile,
    WorkSafeBc,
    Flowsheet
}

export { EncounterItemTypeEnum };
